/* eslint-disable */
import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import CancelIcon from "@mui/icons-material/Cancel";

//Custom components
import DialogToolbarMenuItem from "@/ui/Dialog/DialogToolbarMenuItem";

//Types
import { IDialogToolbarMenuItemDetail } from "@/@types/ui/Dialog";

const DialogToolbarMenuItemDeactivate = React.forwardRef<HTMLLIElement, IDialogToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();

  return <DialogToolbarMenuItem label={t("buttons.deactivate")} icon={<CancelIcon />} {...props} ref={ref} />;
});

export default DialogToolbarMenuItemDeactivate;
